import { SideMenu, NavigationListItem } from '@act/storybook';
import { useState } from 'react';
import CarePortalAvatarMenu from 'react-components/app/CarePortal/CarePortalAvatarMenu';
import { hasPermission } from 'utilities/hasPermissions';
import { useAdminDashboardData } from './hooks/useAdminDashboardData';
import useAdminTools from './hooks/useAdminTools';

const AdminDashboardSideMenu = () => {
  const { actingUser } = useAdminDashboardData();

  const [selectedTab, setSelectedTab] = useState(null);

  const tools = useAdminTools();

  const handleTabClick = (tabId, onClick) => {
    setSelectedTab(tabId);
    onClick();
  };

  return (
    <SideMenu menuTitle="Admin tools" subMenu={<CarePortalAvatarMenu />}>
      {tools.map(
        ({ permission, condition, onClick, icon, text, tabId }) =>
          hasPermission(actingUser, permission) &&
          condition && (
            <NavigationListItem
              key={tabId}
              icon={icon}
              text={text}
              isSelected={selectedTab === tabId}
              onClick={() => handleTabClick(tabId, onClick)}
            />
          )
      )}
    </SideMenu>
  );
};

export default AdminDashboardSideMenu;
